export class ServiceProviderModel {
    name_de_CH = '';
    name_en_GB = '';
    application_duration_de_CH = '';
    application_duration_en_GB = '';
    description_de_CH = '';
    description_en_GB = '';
    category_id = '';
    subcategory_id  = '';
    diagnoses_specific  = '';
    age_group_id  = '';
    company_id  = '';
    website  = '';
    zip_code  = '';
    state  = '';
    country_id = '';
    insurance_id  = '';
    digital_therapy  = '';
    group_therapy  = '';
}